/* mien-colorsearch.js — the infinite colour search (lowheads-style).
   a hue/sat wheel + lightness slider; every feed piece is sampled for its dominant
   garment colour (client-side canvas, cached in localStorage) and the grid re-ranks
   live as you drag toward a colour. vanilla, no deps. opened by [data-mcs-open].
   sources /collections/feed/products.json, falls back to /products.json. */
(function () {
  'use strict';

  var modal = document.getElementById('mcs');
  var opener = document.querySelector('[data-mcs-open]');
  if (!modal || !opener) return;

  var panel = modal.querySelector('.mcs-panel');
  var wheel = modal.querySelector('[data-mcs-wheel]');
  var thumb = modal.querySelector('[data-mcs-thumb]');
  var light = modal.querySelector('[data-mcs-light]');
  var preview = modal.querySelector('[data-mcs-preview]');
  var grid = modal.querySelector('[data-mcs-grid]');
  var hint = modal.querySelector('[data-mcs-hint]');
  var emptyEl = modal.querySelector('[data-mcs-empty]');
  var countEl = modal.querySelector('[data-mcs-count]');

  var CACHE_KEY = 'mien_cs_colors_v1';
  var loaded = false;
  var products = [];        /* { handle, url, title, img, color:{r,g,b}|null, node } */
  var picked = null;        /* {r,g,b} once the user chooses */
  var hue = 0, sat = 0, lum = 0.5;

  /* ---------- colour maths ---------- */
  function hslToRgb(h, s, l) {
    h = (h % 360) / 360;
    function f(p, q, t) {
      if (t < 0) t += 1; if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    var r, g, b;
    if (s === 0) { r = g = b = l; }
    else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = f(p, q, h + 1 / 3); g = f(p, q, h); b = f(p, q, h - 1 / 3);
    }
    return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
  }
  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), h = 0, s = 0, l = (mx + mn) / 2;
    if (mx !== mn) {
      var d = mx - mn;
      s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      if (mx === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return { h: h, s: s, l: l };
  }
  function hexToRgb(hex) {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
    return { r: parseInt(hex.slice(0, 2), 16), g: parseInt(hex.slice(2, 4), 16), b: parseInt(hex.slice(4, 6), 16) };
  }
  /* perceptual "redmean" distance — good enough, cheap */
  function dist(a, b) {
    var rm = (a.r + b.r) / 2, dr = a.r - b.r, dg = a.g - b.g, db = a.b - b.b;
    return Math.sqrt((2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db);
  }

  /* ---------- dominant garment colour (skip neutral bg) ---------- */
  function dominantColor(imgEl) {
    var n = 28, c = document.createElement('canvas');
    c.width = n; c.height = n;
    var ctx = c.getContext('2d');
    try { ctx.drawImage(imgEl, 0, 0, n, n); } catch (e) { return null; }
    var data;
    try { data = ctx.getImageData(0, 0, n, n).data; } catch (e) { return null; } /* CORS-tainted */
    var cr = 0, cg = 0, cb = 0, cc = 0, ar = 0, ag = 0, ab = 0, ac = 0;
    for (var i = 0; i < data.length; i += 4) {
      var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
      if (a < 128) continue;
      ar += r; ag += g; ab += b; ac++;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      var s = mx === 0 ? 0 : (mx - mn) / mx;
      if (s > 0.18 && mx > 45 && mn < 235) { cr += r; cg += g; cb += b; cc++; }
    }
    if (cc > 0 && cc > ac * 0.04) return { r: (cr / cc) | 0, g: (cg / cc) | 0, b: (cb / cc) | 0 };
    if (ac > 0) return { r: (ar / ac) | 0, g: (ag / ac) | 0, b: (ab / ac) | 0 };
    return null;
  }

  /* ---------- colour cache ---------- */
  function readCache() {
    try { return JSON.parse(localStorage.getItem(CACHE_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  var cache = readCache();
  var cacheDirty = false;
  function saveCache() {
    if (!cacheDirty) return;
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
    cacheDirty = false;
  }
  function baseUrl(src) { return (src || '').split('?')[0]; }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- product fetch ---------- */
  function pickImg(p) {
    if (p.images && p.images.length) return typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
    if (p.featured_image) return typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src;
    if (p.image) return typeof p.image === 'string' ? p.image : p.image.src;
    return '';
  }
  function fetchJSON(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function loadProducts() {
    return fetchJSON('/collections/feed/products.json?limit=250')
      .then(function (d) {
        if (d && d.products && d.products.length) return d.products;
        return fetchJSON('/products.json?limit=250').then(function (d2) { return (d2 && d2.products) || []; });
      })
      .then(function (list) {
        products = list.map(function (p) {
          var img = pickImg(p);
          return { handle: p.handle, url: '/products/' + p.handle, title: p.title || '', img: img, color: null, node: null };
        }).filter(function (p) { return p.img; });
      });
  }

  /* ---------- render ---------- */
  function buildTiles() {
    grid.innerHTML = '';
    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'mcs-tile';
      a.href = p.url;
      a.setAttribute('aria-label', (p.title || '').toLowerCase());
      var im = document.createElement('img');
      im.loading = 'lazy';
      im.alt = (p.title || '').toLowerCase();
      im.src = sized(p.img, 400);
      a.appendChild(im);
      p.node = a;
      grid.appendChild(a);
    });
    emptyEl.hidden = products.length > 0;
    /* piece count intentionally not shown */
  }

  /* re-order the grid by distance to the picked colour (closest first); pieces
     with no colour yet, or far from the target, drop to the back / dim out */
  var rankScheduled = false;
  function rank() {
    if (!picked || !products.length) return;
    var scored = products.map(function (p) {
      return { p: p, d: p.color ? dist(picked, p.color) : Infinity };
    });
    scored.sort(function (x, y) { return x.d - y.d; });
    var frag = document.createDocumentFragment();
    scored.forEach(function (s) {
      if (!s.p.node) return;
      s.p.node.classList.toggle('is-far', s.d > 190 || s.d === Infinity);
      frag.appendChild(s.p.node); /* moving an existing node re-appends it in order */
    });
    grid.appendChild(frag);
    if (hint) hint.textContent = 'closest to your colour, first.';
  }
  function scheduleRank() {
    if (rankScheduled) return;
    rankScheduled = true;
    requestAnimationFrame(function () { rankScheduled = false; rank(); });
  }

  /* sample colours with a small concurrency pool; re-rank as results land */
  function sampleColors() {
    var queue = products.slice();
    var running = 0, MAX = 6;
    function next() {
      while (running < MAX && queue.length) {
        (function (p) {
          running++;
          var cached = cache[baseUrl(p.img)];
          if (cached) { p.color = { r: cached[0], g: cached[1], b: cached[2] }; running--; scheduleRank(); next(); return; }
          var im = new Image();
          im.crossOrigin = 'anonymous';
          im.onload = function () {
            p.color = dominantColor(im);
            if (p.color) { cache[baseUrl(p.img)] = [p.color.r, p.color.g, p.color.b]; cacheDirty = true; }
            running--; scheduleRank(); next();
          };
          im.onerror = function () { running--; next(); };
          im.src = sized(p.img, 64);
        })(queue.shift());
      }
      if (!queue.length && running === 0) saveCache();
    }
    next();
  }

  /* ---------- pick state ---------- */
  function placeThumb() {
    var rect = wheel.getBoundingClientRect();
    var rad = rect.width / 2;
    var a = hue * Math.PI / 180;
    var x = rad + rad * sat * Math.sin(a);
    var y = rad - rad * sat * Math.cos(a);
    thumb.style.left = x + 'px';
    thumb.style.top = y + 'px';
  }
  function apply(rerank) {
    picked = hslToRgb(hue, sat === 0 ? 0.0001 : sat, lum);
    if (preview) preview.style.background = 'rgb(' + picked.r + ',' + picked.g + ',' + picked.b + ')';
    thumb.style.background = 'rgb(' + picked.r + ',' + picked.g + ',' + picked.b + ')';
    wheel.setAttribute('aria-valuetext', 'rgb ' + picked.r + ' ' + picked.g + ' ' + picked.b);
    placeThumb();
    if (rerank) scheduleRank();
  }
  function setFromRgb(rgb, rerank) {
    var h = rgbToHsl(rgb.r, rgb.g, rgb.b);
    hue = h.h; sat = h.s; lum = h.l;
    if (light) light.value = Math.round(lum * 100);
    apply(rerank);
  }
  function setFromWheel(clientX, clientY) {
    var rect = wheel.getBoundingClientRect();
    var rad = rect.width / 2;
    var dx = clientX - (rect.left + rad), dy = clientY - (rect.top + rad);
    var r = Math.min(1, Math.hypot(dx, dy) / rad);
    var ang = Math.atan2(dx, -dy) * 180 / Math.PI;
    if (ang < 0) ang += 360;
    hue = ang; sat = r;
    apply(true);
  }

  /* ---------- wheel drag ---------- */
  var dragging = false;
  function onDown(e) { dragging = true; wheel.setPointerCapture && e.pointerId != null && wheel.setPointerCapture(e.pointerId); setFromWheel(e.clientX, e.clientY); e.preventDefault(); }
  function onMove(e) { if (dragging) setFromWheel(e.clientX, e.clientY); }
  function onUp() { dragging = false; }
  wheel.addEventListener('pointerdown', onDown);
  window.addEventListener('pointermove', onMove);
  window.addEventListener('pointerup', onUp);
  /* keyboard nudge on the wheel */
  wheel.addEventListener('keydown', function (e) {
    var step = 6;
    if (e.key === 'ArrowRight') hue = (hue + step) % 360;
    else if (e.key === 'ArrowLeft') hue = (hue + 360 - step) % 360;
    else if (e.key === 'ArrowUp') sat = Math.min(1, sat + 0.06);
    else if (e.key === 'ArrowDown') sat = Math.max(0, sat - 0.06);
    else return;
    e.preventDefault(); apply(true);
  });

  if (light) light.addEventListener('input', function () { lum = (parseInt(light.value, 10) || 0) / 100; apply(true); });

  modal.querySelectorAll('[data-mcs-presets] .mcs-preset').forEach(function (b) {
    b.addEventListener('click', function () { setFromRgb(hexToRgb(b.getAttribute('data-color')), true); });
  });
  var clearBtn = modal.querySelector('[data-mcs-clear]');
  if (clearBtn) clearBtn.addEventListener('click', function () {
    picked = null;
    products.forEach(function (p) { if (p.node) p.node.classList.remove('is-far'); });
    buildOrderReset();
    if (preview) preview.style.background = '';
    if (hint) hint.textContent = 'drag the dot — the feed sorts to your colour.';
  });
  function buildOrderReset() {
    var frag = document.createDocumentFragment();
    products.forEach(function (p) { if (p.node) frag.appendChild(p.node); });
    grid.appendChild(frag);
  }

  /* ---------- open / close ---------- */
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mcs-open');
    if (panel) panel.focus();
    if (!loaded) {
      loaded = true;
      loadProducts().then(function () {
        buildTiles();
        if (products.length) sampleColors();
      });
    }
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mcs-open');
    saveCache();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  opener.addEventListener('click', open);
  modal.addEventListener('click', function (e) { if (e.target.closest('[data-mcs-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
})();
